import React, { useRef, useState } from 'react';
import '../styles/Contact.css'; // We'll define styling shortly
import emailjs from '@emailjs/browser';

function Contact() {
  const formRef = useRef();    // Allows us to reference the form DOM
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setIsSubmitted(false);

    // Replace with your actual EmailJS config
    emailjs.sendForm(
      'service_2k8tmr2', //serviceID
      'template_rvvr1un', //tempalte ID
      formRef.current,
      'xuhW5VGrxnjBdFXqF' //public key
    )
    .then((result) => {
      console.log('Email sent:', result.text);
      setIsSubmitted(true);
      setLoading(false);
      // Optionally reset the form
      formRef.current.reset();
    })
    .catch((error) => {
      console.error('Email send error:', error);
      setLoading(false);
    });
  };

  return (
    <div className="contact-container">
      <div className="contact-form-wrapper">
        <h2>Contact Us</h2>
        
        {isSubmitted && (
          <p className="success-message">
            Thank you! Your message has been sent successfully.
          </p>
        )}
        
        <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
          <div className="form-field">
            <label htmlFor="user_name">Name</label>
            <input type="text" id="user_name" name="user_name" required />
          </div>

          <div className="form-field">
            <label htmlFor="user_email">Email</label>
            <input type="email" id="user_email" name="user_email" required />
          </div>

          <div className="form-field">
            <label htmlFor="referral">How did you hear about us?</label>
            <div className="form-field">
              <select id="referral" name="referral" required>
                <option value='friendFamily'>Friend or Family</option>
                <option value='advertisement'>Advertisement</option>
                <option value='google'>Google/Search Engine</option>
                <option value='dream'>Divine intervention/dream</option>
                <option value='other'>Other</option>
              </select> 
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" rows="5" required />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>

      <div className="contact-info">
        <h3>Get in Touch</h3>
        <p>Feel free to reach out with any inquiries or questions.</p>
        <p>Email: sales@northcentralcarpentry.com</p>
        <p>Phone: +1 (954) 471-2042</p>
        {/* Optionally add a Google Maps embed or address */}
      </div>
    </div>
  );
}

export default Contact;
